// src/router/routes.js
import Dashboard from "@/components/Pages/Dashboard.vue";
import ListSchedules from "@/components/Pages/ListSchedules.vue";
import Elements from "@/components/Routes/Elements.vue";
import OIDCLogin from "@/components/Pages/OIDCLogin.vue";
import OIDCCallback from "@/components/Pages/OIDCCallback.vue";
import ReturnChannel from "@/components/Pages/ReturnChannel.vue";
import DownloadWindowSettings from "@/components/Pages/DownloadWindowSettings.vue";
import Docs from "@/components/Pages/Docs.vue";
import Devices from "@/components/Pages/Devices.vue";

const routes = [
    // Tela de login independente
  {
    path: "/login",
    name: "login",
    component: OIDCLogin,
    meta: { title: "Login" },
  },

    // Callback do provedor OIDC
  {
    path: "/auth/callback",
    name: "oidc-callback",
    component: OIDCCallback, // Componente de Callback
    meta: { title: "Redirecting ...", standalone: true },
  },

  {
    path: "/docs",
    name: "docs",
    component: Docs,
    meta: { title: "API Docs", requiresAuth: true, standalone: true },
  },

  // Rotas protegidas
  {
    path: "/",
    component: Elements,
    meta: { requiresAuth: true },
    children: [
      { path: "", redirect: "/dashboard" },
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: { title: "Dashboard" },
      },
      {
        path: "schedule",
        name: "schedule",
        component: ListSchedules,
        meta: { title: "Listagem de Agendamentos" }, // Define o título
      },
      {
        path: "return-channel",
        name: "return-channel",
        component: ReturnChannel,
        meta: { title: "Confirmação de Recebimento" }, // Define o título
      },
      {
        path: "devices",
        name: "devices",
        component: Devices,
        meta: { title: "Dispositivos" },
      },
      {
        path: "settings",
        name: "settings",
        component: DownloadWindowSettings,
        meta: { title: "Configurações" },
      },
    ],
  },

    // Fallback
  { path: "/:pathMatch(.*)*", redirect: "/dashboard" },
];

export default routes;
